import React, {useEffect, useRef, useState} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {getLanguage, t} from 'react-switch-lang';
import {
  getAllFrequencyOccurenceRisks,
  createFrequencyOccurenceRisk,
  deleteFrequencyOccurenceRisk,
  updateFrequencyOccurenceRisk,
} from '../../../services/FrequencyOccurenceRisks/frequencyOccurenceRisks';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import Swal from "sweetalert2";
import AddIcon from '../Metodologies/plus.png';

const FrequencyOccurenceRisks = () => {
  const [frequencyOccurenceRisks, setFrequencyOccurenceRisks] = useState([]);
  const [query, setQuery] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllFrequencyOccurenceRisks();
        setFrequencyOccurenceRisks(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  // Opcije za select moraju biti u formatu {value, label}

  // const formatedDepartments = frequencyOccurenceRisks.map((d) => ({
  //   label: d.name,
  //   value: d.id,
  // }));

  const columns = [
    {
      dataIndex: 'name',
      title: t('common.name'),
      editable: true,
      placeholder:`${t('common.placeholder.name')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
        
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('common.nameEn'),
      editable: true,
      placeholder:`${t('common.placeholder.nameEn')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
        
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.id = editingRecord.id;
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await updateFrequencyOccurenceRisk(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('message.updateSuccess2', {entity: t('frequencyOccurenceRisks.frequencyOccurenceRisk')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('frequencyOccurenceRisks.frequencyOccurenceRiskExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('frequencyOccurenceRisks.frequencyOccurenceRiskExists')],
          },
        ]);
      }
    }
  };

  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await createFrequencyOccurenceRisk(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('message.addSuccess2', {entity: t('frequencyOccurenceRisks.frequencyOccurenceRisk')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('frequencyOccurenceRisks.frequencyOccurenceRiskExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('frequencyOccurenceRisks.frequencyOccurenceRiskExists')],
          },
        ]);
      }
    }
  };

  const onDelete = async (record) => {
    let response;
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('frequencyOccurenceRisks.frequencyOccurenceRisk'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
        // text: t('question.delete', {entity: t('frequencyOccurenceRisks.frequencyOccurenceRisk')}),
        confirmButtonText: t('common.delete2').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            response = await deleteFrequencyOccurenceRisk(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess2', {entity: t('frequencyOccurenceRisks.frequencyOccurenceRisk')}),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('message.deleteFailed', {entity: t('frequencyOccurenceRisks.frequencyOccurenceRisk')}),
              icon: 'error',
            });
          }
        },
      });
    });
  };

  const addButton = useRef();

  return (
    <div className="frequency-occurence-risks administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search">
          <SearchBox
            placeholder={t('frequencyOccurenceRisks.searchFrequencyOccurenceRisks')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('frequencyOccurenceRisks.add')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/frequency-occurence-risks"
        query={query}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        columns={columns}
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};

export default FrequencyOccurenceRisks;